module.exports = __webpack_public_path__ + "img/12.3a365162.jpg";